import { render, staticRenderFns } from "./billing-info-content-summary-table.component.vue?vue&type=template&id=f68deb66&scoped=true&"
import script from "./billing-info-content-summary-table.component.vue?vue&type=script&lang=ts&"
export * from "./billing-info-content-summary-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./billing-info-content-summary-table.component.vue?vue&type=style&index=0&id=f68deb66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68deb66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
